import BookingModal from "@/components/BookingModal";

/**
 * Convenience wrapper for the pages that want the booking modal to open
 * right after a lead form succeeds. One `open`/`prefill`/`onClose`
 * contract, so every call site just does:
 *
 *   const [bookCall, setBookCall] = useState({ open: false, prefill: null });
 *   <LeadForm ... onSuccess={({ prefill }) => setBookCall({ open: true, prefill })} />
 *   <BookCallFlow {...bookCall} onClose={() => setBookCall({ open: false, prefill: null })} />
 *
 * There's no separate "book a call?" prompt step anymore -- the modal
 * itself opens directly, already set to the right persona (Individual vs
 * Corporate) from which form the visitor just submitted, with its own
 * "Skip" affordance to dismiss without booking.
 */
export default function BookCallFlow({ open, prefill, onClose }) {
  return <BookingModal open={open} prefill={prefill} onClose={onClose} />;
}
